import { AppBar } from '@mui/material';
import React, { ReactElement, useState } from 'react';
import EvoBackIcon from '../../../../../assets/new-icons/freccia.svg';
import { dashboardPagesMenu, evoHuntPages } from '../../../../../menu';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ReactiveDrawerMenu from '../menu/ReactiveDrawerMenu';
import evohuntLogo from '../../../../../assets/evohunt_logo.png';
import { getLoggedUserId, getLoggedUserRole } from '../../../../../common/function/utilities';
import { ROLE } from '../../../../../constants/constants';
import { useTimer } from '../../../../../contexts/timerContext';

interface IEvohuntMobileHeaderProps {
	handleBack: () => void;
}

const EvoHuntMobileHeader: React.FC<IEvohuntMobileHeaderProps> = ({ handleBack }: IEvohuntMobileHeaderProps): ReactElement => {
	const location = useLocation();
	const navigate = useNavigate();

	const [searchParams] = useSearchParams();

	const { isRunning } = useTimer();
	const [alertTimer, setAlertTimer] = useState<boolean>(false);
	const [alertTimerCallback, setAlertTimerCallback] = useState<string | undefined>(undefined);

	const mainPages: boolean =
		location.pathname === '/' ||
		location.pathname === '/messaggi' ||
		location.pathname === '/notifiche' ||
		location.pathname === '/tipsTabbed' ||
		location.pathname === '/aziendaProfileHome' ||
		location.pathname === '/userProfileCandidato' ||
		location.pathname === '/userProfileStartup' ||
		location.pathname === '/terms-and-conditions' ||
		location.pathname === '/privacy-policy' ||
		location.pathname === '/cookies-policy' ||
		(location.pathname === '/preview' && !searchParams.get('back')) ||
		(location.pathname === '/blind-preview' && !searchParams.get('back')) ||
		(location.pathname === '/candidate-preview' && !searchParams.get('back')) ||
		(location.pathname === '/query-preview' && !searchParams.get('back')) ||
		(location.pathname === '/idea-preview' && !searchParams.get('back')) ||
		location.pathname === '/registration' ||
		(location.pathname === '/Login' && !!searchParams.get('company')) ||
		location.pathname === '/homeCandidato' ||
		location.pathname === '/homeAzienda' ||
		location.pathname === '/homeIdeatore' ||
		location.pathname === '/homeStartup';

	const handleHomeClick = (): void => {
		if (isRunning) {
			setAlertTimer(true);
			setAlertTimerCallback('home');
		} else {
			if (getLoggedUserRole() === ROLE.USER) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeCandidato.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.COMPANY) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeAzienda.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.IDEATOR) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeIdeatore.path}`, {replace: true});
			} else if (getLoggedUserRole() === ROLE.STARTUP) {
				navigate(`../${evoHuntPages.evohunt.subMenu.homeStartup.path}`, {replace: true});
			} else {
				navigate(`../${dashboardPagesMenu.evohunt.path}`);
			}
		}
	};

	return (
		<>
			{location.pathname !== '/' && (
				<div className={`appBarContainer`}>
					<AppBar position='fixed' className='header_appbar'>
						<div className='row p-2'>
							<div className='col-2 text-start flex-center-start'>
								&nbsp;&nbsp;
								{mainPages
									? <></>
									: <img src={EvoBackIcon} alt='Indietro' onClick={handleBack} className='cursor-link' style={{ width: '1rem' }} />}
							</div>
							<div className='col-8 flex-center-center'>
								<img src={evohuntLogo} alt='evohunt_logo' onClick={handleHomeClick} style={{ width: '12rem' }} className='cursor-link' />
							</div>
							<div className='col-2 text-center'>
								{getLoggedUserId() ? <ReactiveDrawerMenu iconSize='2rem' color='#007bfb' /> : <div style={{ width: "5rem" }}></div>}
							</div>
						</div>
					</AppBar>
				</div>
			)}
		</>
	);
};

export default EvoHuntMobileHeader;
